module.exports = __webpack_public_path__ + "static/media/remember.07976395.jpg";